// src/components/SettlementSection.jsx
import React from "react";

/**
 * SettlementSection
 * Props:
 *  - imageSrc (string): image url, default is a placeholder
 *  - imageAlt (string): alt text for the image
 *  - reverse (boolean): if true, image appears on the right on md+ screens
 */
export default function SectionFive({
  imageSrc = "https://dwy9ix7d387oz.cloudfront.net/attachments/2025/8/b4231f74-b8ab-4ae1-83b8-c6182dfecee3.jpg",
  imageAlt = "Person injured next to car (placeholder)",
  reverse = false,
}) {
  return (
    <section className="bg-[#FBF7F6] py-36 px-4">
      <div className="max-w-6xl mx-auto">
        <div
          className={`flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12 lg:gap-24${
            reverse ? "md:flex-row-reverse" : ""
          }`}
        >
          {/* Image column */}
          <div className="w-full md:w-1/2 flex-shrink-0">
            <img
              src={imageSrc}
              alt={imageAlt}
              className="w-full h-auto object-cover rounded-sm shadow-sm"
              loading="lazy"
            />
          </div>

          {/* Content column */}
          <div className="w-full md:w-1/2">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-gray-900 mb-4">
              What Is a Car Accident Settlement?
            </h2>

            <p className="text-sm md:text-base text-gray-700 leading-7 max-w-prose mb-6">
              A settlement is a financial agreement where the at-fault party—or more often,
              their insurance company—agrees to compensate you for accident-related losses
              without going to trial. Most claims resolve this way, helping you avoid court
              delays while still recovering money for injuries, lost income, and more.
            </p>

            <div>
              <button
                type="button"
                className="bg-red-700 hover:bg-red-800 text-white font-semibold px-6 py-3 rounded-md shadow transition-transform transform hover:-translate-y-0.5"
                onClick={() => {
              const el = document.getElementById('injury-compensation-form');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
              >
                Get A Free Lawsuit Case Review
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
